import { NgModule } from '@angular/core';

import { ToggleSidebarService } from '@shared/services';
import { SharedModule } from '@shared/shared.module';

import { LegalNoticeComponent } from './legal-notice.component';

@NgModule({
  imports: [SharedModule],
  declarations: [LegalNoticeComponent
  ],
  providers: [ToggleSidebarService]
})

export class LegalNoticeModule {
}
